import React, { FunctionComponent, ReactNode } from 'react'
import styles from '~/styles/container.module.css'

interface Props {
  children: ReactNode
  className?: string
}

const Container: FunctionComponent<Props> = ({
  children,
  className = '',
}: Props) => (
  <div 
    className={`mx-auto px-2 ${className} ${styles.container}`}
  >
    {children}
  </div>
)

export default Container
